const Form012EN = {
    stepName: {
        basicInformation: "Basic Information",
        activitiesInformation: "Information on Activities in the Project",
        effectiveness: "Project Effectiveness and Comments",
        projectEvaluation: "Evaluation on the Project",
        incomeExpenditure: "Statement of Activity Income & Expenditure",
        cost: "Statement of Administration Cost and Project Coordination Costs",
        confirmation: "Confirmation",
    },
    title: {
        title1: "School-based After-school Learning and Support Programmes {{schoolYear}} School Year",
        title2: "Community-based Project – Final Report ({{deadline}})",
        title3: "(The original copy should be returned to the Student Special Support Section {{sumbitDeadline}})",
    },
    important: {
        title: "Personal Information Collection Statement",
        note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s): ",
        note2: "(a) processing employment-related matters;",
        note3: "(b) processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        note4: "(c) auditing;",
        note5: "(d) conducting research and compiling statistics to facilitate planning of education services;",
        note6: "(e) processing matters relating to the development of the education profession;",
        note7: "(f) administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",
        note8: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application. ",
        note9: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above. ",
        note10: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee. ",
        note11: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },
    notes: {
        tips1: "1. All information of the e-Form contained herein shall be subject to the application form on the EDB website",
        tipsUrl:
            "https://www.edb.gov.hk/en/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. School-based After-school Learning and Support Programmes Community-based Projects – Progress Report (up to 31 December of the school year) (This form, duly completed and signed, should be returned to the Student Special Support Section of EDB on or before 31 January of the school year).",
        remarks: {
            tips1: "Eligible students: students in receipt of Comprehensive Social Security Assistance (CSSA), full grant under the Student Finance Assistance Schemes (SFAS) or the needy students under the discretionary quota (only applicable to the needy students identified by the collaborating school(s)).",
            tips2: "Non-eligible students: students who have to pay fees to join an activity. These students <u>must pay full fee</u>; full fee means the <span><u><b>actual</b></u> cost</span> of an activity for each participating student (including eligible and non-eligible students) (e.g. if the actual cost for the activity is $1,000 with a total of 6 eligible students and 4 non-eligible students participating in the activity, the cost for each participating student should be $100; each non-eligible student should therefore pay $100).",
            tips3: "Status of activity: the progress should be stated as: <b>(a) completed or (b) cancelled.</b>",
            tips4: "Amount of grant: the amount allocated for the activity under the approved project; <u>(the grant only subsidise eligible students;</u> non-eligible students must pay full fee).",
            tips5: `Other income: other sources of revenue such as the fee paid by the non-eligible students, donation and sponsorship.`,
            tips6: `Expenses: the expenses for organising the activity (including subsidy by NGO in the expense). `,
            tips7: `For a cancelled activity, the administration cost to be deducted is calculated based on the percentage approved to the administration cost\n(Refer to <span><b>-Part J</b></span> of the application form):\n <div style="display:flex;align-items:center;">percentage to be deducted =  <div style="display:inline-block;"><div style="display:flex;flex-direction: column;"><span>approved administration cost (B)</span> <hr /> <span>approved total activity grant (A)</span></div></div> × 100%  (round to two decimal places)</div> \nThus, the administration cost to be deducted: amount of grant of the cancelled activity   percentage to be deducted`,
            tips8: `For a cancelled activity, the project coordination cost to be deducted is calculated based on the percentage approved to the project coordination cost\n(Refer to <span><b>Part J</b></span> of the application form):\n <div><span style="display: inline-block;transform: translateY(11px);">percentage to be deducted =</span>  <div style="display:inline-block;"><div style="display:flex;flex-direction: column;"><span>approved project coordination cost (C) </span> <hr /> <span>approved total activity grant (A) </span></div></div> <span style="display: inline-block;transform: translateY(11px);">× 100%  (round to two decimal places)</span></div>\n<div>Thus, the project coordination cost to be deducted: amount of grant of the cancelled activity  percentage to be deducted</div>`,
            tips9: "The three types of students:<br>- NCS (non-Chinese speaking students)<br>- SEN (students with special educational needs)<br>- NAC (newly-arrived-children)",
            tips10: `For activities open to the community, <u><b>priority</b></u> should be given to eligible students from "Od" and "Pv" schools\n- Od (students from government, aided and caput schools, schools under the Direct Subsidy Scheme and private schools not listed in (I))\n- Pv (students from private schools)\n- Cs (students from collaborating schools listed in (I))`,
        },
    },
    label: {
        statement: "Statement",
        basicInformation: "Basic Information",
        organisationName: "Name of Organisation",
        projectTitle: "Project Title",
        applicationRefNO: "Project reference No.",
        projectCoordinator: "Project Coordinator",
        contactPerson: "Contact Person",
        contactTelNo: "Contact Tel. No.",
        stepOption: {
            ActivitiesWithSchoolPart1:
                "Activities held with collaborating school(s)",
            ActivitiesOpenCommunityPart1: "Activities open to the community",
        },
        selectContent: "Select the content to be filled in",
        activitiesSchoolTips:
            "Please provide information on all approved activities.",
        activitiesInformation: "A. Information on Activities in the Project",
        activitiesSchoolIa:
            "(I) (a) Activities held with collaborating school(s) (List out all the approved activities)",
        activitiesStudentsNo:
            "No. of participating eligible students in approved activities",
        activitiesStudentsNoBefore: "No. of participating eligible students ",
        activitiesStudentsNoAfter: "  in this approved activity",
        activityName: "Name of activity",
        schoolName: "Name of collaborating school(s)",
        actualNo: "Actual no. of students participated",
        remark: "Remark",
        eligibleStudents: "Eligible students",
        nonEligiblestudents: "Non-eligible students",
        secdNoTitle: "No. of Secondary School students",
        remarkEg: "e.g. activity dates: Every Mon,Wed and Fri 4:00–5:30pm",
        priNoTitle: "No. of Primary School students",
        specNoTitle: "No. of Special School students",
        average: "Average attendance rate(%)",
        isSchedule: "Status of activity",
        financialReport: "Financial report",
        flagOption: {
            0: "No",
            1: "Yes",
        },

        a1: "Amount of grant (HK$) (A1)",
        b1: "Other income (HK$) (B1)",
        c1: "Subsidy from NGO (HK$) (C1)",
        d1: "Expenses (HK$)(D1)",
        a2: "Amount of grant (HK$) (A2)",
        b2: "Other income (HK$) (B2)",
        c2: "Subsidy from NGO (HK$) (C2)",
        d2: "Expenses (HK$) (D2)",
        totalTitle: "Total",
        activitiesTotalNo: "Total no. of activities",
        completedActivitiesTotalNo: "Total no. of completed activities",
        priTotalNo: "Total no. of Primary School students",
        secdTotalNo: "Total no. of Secondary School students",
        specTotalNo: "Total no. of Special School students",
        manTimesTotal: "Total man-times (Total no. of students listed above)",
        a1Total: "Total (HK$) (A1)",
        b1Total: "Total (HK$) (B1)",
        c1Total: "Total (HK$) (C1)",
        d1Total: "Total (HK$) (D1)",
        a2Total: "Total (HK$) (A2)",
        b2Total: "Total (HK$) (B2)",
        c2Total: "Total (HK$) (C2)",
        d2Total: "Total (HK$) (D2)",
        activitiesSchoolIb: `(I) (b) Information of participating students in collaborating schools ({{deadline}})`,
        activitiesSchoolIbi: "(i) Students in receipt of CSSA",
        primarySchool: "Primary School",
        studentsNo: "No. of students",
        studentsTitleBefore: "Please provide the no. of students",
        studentsTitleAfter: "  per type where applicable",
        NCS: "Non-Chinese speaking students",
        applicableType: "If applicable",
        SEN: "Students with Special Educational Needs",
        NAC: "Newly-arrived children",
        secondarySchool: "Secondary School",
        specialSchool: "Special School",
        activitiesSchoolIbii: "(ii) Students in receipt of SFAS",
        total: "Total salary",
        activitiesSchoolIbiii:
            "(iii) Total no. of needy students under the discretionary quota (not exceeding 25%) (only applicable to the students identified by the collaborating school(s))",
        activitiesSchoolIbiv:
            "(iv) Total no. of eligible students beneficiaries: (i) + (ii) + (iii) = ",
        activitiesSchoolIbivBefore:
            "(iv) Total no. of eligible students",
        activitiesSchoolIbivAfter:
            "  beneficiaries: (i) + (ii) + (iii) = ",
        activitiesSchoolIbv:
            "(v) Total no. of non-eligible students (must pay full fee)",
        activitiesSchoolIbvBefore: "(v) Total no. of non-eligible students",
        activitiesSchoolIbvAfter: "  (must pay full fee)",
        activitiesSchoolIbTotal: "Total no. of students: (iv) + (v) =",
        schoolTypeOption: {
            primarySchool: "Primary School",
            secondarySchool: "Secondary School",
            specialSchool: "Special School",
        },
        activitiesCommunityIIA:
            "(II) (a) Activities open to the community (List out all the approved activities)",
        actualSituationOption: {
            "(a)": "(a) completed",
            "(b)": "(b) cancelled",
        },
        actualSituation: "Status of activity",
        approvedStudentsNo:
            "No. of participating eligible students in approved activities",
        Od: "Od",
        Pv: "Pv",
        Cs: "Cs",
        odTips: "students from government, aided and caput schools, schools under the Direct Subsidy Scheme and private schools not listed in (I)",
        pvTips: "students from private schools",
        csTips: "students from collaborating schools listed in (I)",
        primaryOd: "Od(Primary)",
        primaryPv: "Pv(Primary)",
        primaryCs: "Cs(Primary)",
        secondaryOd: "Od(Secondary)",
        secondaryPv: "Pv(Secondary)",
        secondaryCs: "Cs(Secondary)",
        specialOd: "Od(Special)",
        specialPv: "Pv(Special)",
        specialCs: "Cs(Special)",
        averageRate: "Average attendance rate(%)",
        odTotal: "Total no. of Od",
        pvTotal: "Total no. of Pv",
        csTotal: "Total no. of Cs",
        primaryOdTotal: "Total no. of Od(Primary)",
        primaryPvTotal: "Total no. of Pv(Primary)",
        primaryCsTotal: "Total no. of Cs(Primary)",
        secondaryOdTotal: "Total no. of Od(Secondary)",
        secondaryPvTotal: "Total no. of Pv(Secondary)",
        secondaryCsTotal: "Total no. of Cs(Secondary)",
        specialOdTotal: "Total no. of Od(Special)",
        specialPvTotal: "Total no. of Pv(Special)",
        specialCsTotal: "Total no. of Cs(Special)",
        approvedStudentsNoTotal:
            "Total no. of participating eligible students in approved activities",
        activitiesCommunityIIB: `(II) (b) Information of students joining the community activities ({{deadline}})`,
        activitiesCommunityIIBvi: "(vi) Students in receipt of CSSA",
        countByHead: "Count by heads",
        primaryHeads: "Primary",
        secondaryHeads: "Secondary",
        specialHeads: "Special School",
        totalHeads: "Total",
        typeStudentsNo:
            "Provide the no. the following types of students where applicable",
        typeStudentsNoBefore: "Please provide the no. of students",
        typeStudentsNoAfter: "  per type where applicable",
        ncs: "NCS",

        sen: "SEN",
        nac: "NAC",
        activitiesCommunityIIBvii: "(vii)  Students in receipt of SFAS",
        activitiesCommunityIIBviii:
            "(viii) Total no. of eligible students benefitted: (vi) + (vii) =",

        totalViii: "Total(Count by heads): (vi)Total + (vii)Total = ",
        totalNcs: "Total(NCS): (vi)NCS + (vii)NCS =",
        totalSen: "Total(SEN): (vi)SEN + (vii)SEN =",
        totalNac: "Total(NAC): (vi)NAC + (vii)NAC =",
        activitiesCommunityIIBix: "(ix) Total no. of non-eligible",
        activitiesCommunityIIBixBefore:
            "(ix) Total no. of non-eligible students",
        activitiesCommunityIIBixAfter: "  (must pay full fee):",
        activitiesCommunityIIBTotal: "Total no. of students (viii) + (ix) =",
        activitiesCommunityIIBx: "Total no. of students (viii) + (ix) =",
        totalX: "Total(Count by heads): (viii)Total + (ix)Total =",
        totalXNcs: "Total(NCS): (viii)NCS + (ix))NCS =",
        totalXSen: "Total(SEN): (viii)SEN + (ix))SEN =",
        totalXNac: "Total(NAC): (viii)NAC + (ix))NAC =",
        financialSummaryIII: `(III) Financial Summary of the whole project ({{deadline}})`,
        summaryE: "(E) Administration cost",
        summaryF: "(F) Project coordination cost",
        summaryG:
            "(G) Administration and project coordination cost subsidised by NGO",
        summaryH: "(H) Total project expenditure = (D1) + (D2) + (E) + (F)",
        summaryI:
            "(I) Total amount of approved grant (i.e. item 5 of part J of the application form)",
        summaryJ: "(J) Amount received",
        summaryK: "(K) Interest earned (if any)",
        summaryL:
            "(L) Total project income = (B1) + (B2) + (C1) + (C2) + (G) + (J) + (K)",
        summaryBalance: "Balance = (L) – (H)",
        summaryTips:
            "Please fill in accordance with <b>item 5 of part J of the application form</b>, i.e. the total amount of grant approved to your organisation before the due date of this progress report",
        effectiveness: "B. Project Effectiveness",
        effectivenessTips:
            "In general, how would you rate the achievements of the activities conducted / in progress to the benefitted eligible students?",
        learningEffectiveness: "Learning effectiveness",
        learningMotivation: "a) Students' motivation for learning",
        effectivenessOption: {
            1: "Significant Improved",
            2: "Moderate Improved",
            3: "Slight Improved",
            4: "No Change",
            5: "Declining",
            6: "Not Applicable",
        },
        studySkills: "b) Students' study skills",
        academicAchievement: "c) Students' academic achievement",
        outsideExperience: "d) Students' learning experience outside classroom",
        overallEffectivenes:
            "e) Your overall view on students' learning effectivenes",
        development: "Personal and Social Development",
        selfEsteem: "f) Students' self-esteem",
        selfManagement: "g) Students' self-management skills",
        socialSkills: "h) Students' social skills",
        interpersonalSkills: "i) Students' interpersonal skills",
        cooperativenessSkill: "j) Students' cooperative skill with others",
        attitudesToward: "k) Students' attitudes toward schooling",
        outlookOnLife: "l) Students' outlook on life",
        overallView:
            "m) Your overall view on students' personal and social development",
        communityInvolvement: "Community Involvement",
        participation:
            "n) Situation on students' participation in extra-curricular and voluntary activities",
        belongingSense: "o) Students' sense of belonging",

        understanding: "p) Students' understanding on the community",
        overallView2: "q) Your overall view on students' community involvement",
        comments: "C. Comments on the project conducted",
        difficulties:
            "Have you encountered any of the following problems/difficulties when implementing the project? \n(Please put a “√”in the appropriate box. You may choose more than one box.)",
        difficultiesOption: {
            manpower: "Insufficient manpower to conduct the activities",
            eligibleStudents:
                "Collaborating schools unable to provide sufficient no. of eligible students (i.e. students in receipt of CSSA and SFAS)",
            eligibleUnwilling:
                "Eligible students unwilling to join the programmes",
            collaborating:
                "Collaborating schools unable to provide appropriate support",
            unableEmploy:
                "Unable to employ suitable tutors to conduct activities",
            funds: "Complicated requirements for handling funds disbursed by EDB",
            reportComplicated:
                "The reporting requirements too complicated and time-consuming",
            other: "Others",
        },
        specify: "Please specify",
        specifyReason: "Please specify the reasons",
        otherMsg: "suggestions",
        suggestions:
            "If you have other suggestions (e.g. mode of collaboration, nature of activities, etc.) on the project, please specify below",
        incomeExpenditure: `E(I). Statement of Activity Income & Expenditure ({{deadline}})`,
        projectInformation: "Basic information of the project",
        actualEligibleNo: "Actual no. of eligible students participated",
        actualNoneligibleNo: "Actual no. of non-eligible students participated",
        incomeItems: "Income Items",
        grantAmount: "Amount of grant approved for this activity",
        nonEligibleFees: "Fees collected from non-eligible students",
        others: "Others",
        othersIncome: "Others",
        otherSpecify: "Please specify",
        othersExpenditure: "Others",
        totalA: "Total Income(A)",
        subsidyB: "Subsidy by NGO(B)",
        expenditureItems: "Expenditure Items",
        totalGroups: "Total groups",
        sessions: "Sessions",
        hr: "Hr(s)",
        tutorFee: "Tutor fee",
        ngoChopFile: "Chop",
        halfDay: "Half day",
        fullDay: "Full day",
        tutorsNo: "No. of tutors",
        hourlySalary: "Hourly salary",
        otherStaffNo: "No. of other staff",
        socialWorkersNo: "No. of social workers",
        material: "Material",
        campAdmissionFee: "Camp / Admission fee",
        studentsMeal: "Students' meal",
        transportationFee: "Activity transportation fee",
        volunteersNo: "No. of volunteers",
        volunteersAllowance: "Volunteers allowance",
        totalC: "Total Expenditure(C)",
        balance: "Balance(A+B-C)",
        time: "Time",
        fullOrHalf: "Half day or full day",
        fullOrHalfOption: {
            half: "Half day",
            full: "Full day",
        },
        costA: "Approved Grant for Administration Cost(A)",
        AdministExpenses: "Administration Expenses",
        transportationFees: "Staff transportation fees",
        photoCopy: "Photo-copying",
        stationery: "Stationery",
        postage: "Postage",
        administrationCostA: "Approved Grant for Administration Cost (A)",
        administrationTotalB:
            "Approved Grant for Administration Cost after deduction (B) (B = A - E1 - E2)",
        administrationCostC: "Balance (C) = (B + G - E)",
        administrationCostE: "Total Expenditure for Administration (E)",
        administrationCostF:
            "Deducted Grant for Administration Cost due to cancellation of activities (E1 + E2)",
        administrationCostG:
            "Administration Cost Subsidised by NGO (if any) (G)",
        projectCoordinationCostA:
            "Approved Grant for Project Coordination Cost (A)",
        projectCoordinationTotalB:
            "Approved Grant for Project Coordination Cost after deduction (B) (B = A - F1 - F2)",
        projectCoordinationCostC: "Balance (C) = (B + G - F)",
        projectCoordinationCostE:
            "Total Expenditure for Project Coordination Cost (F)",
        projectCoordinationCostF:
            "Deducted Grant for Project Coordination Cost due to cancellation of activities (F1 + F2)",
        projectCoordinationCostG:
            "Project Coordination Cost Subsidised by NGO (if any) (G)",
        statementAdministrationCost: `Statement of Administration Cost ({{deadline}})`,
        statementProjectCoordinationCost: `Statement of Project Coordination Cost ({{deadline}})`,
        ngoOption: {
            ngo: "Name and Post of Head of NGO",
            department: "Name and Post of Head of Department",
            subsidiaryOrganisation:
                "Name and Post of Head of Subsidiary Organisation",
            project: "Name and Post of Head of Project Coordinator",
        },
        checkedFlag:
            "I have already checked all the information provided above and verified that all expenditure receipts are true and correct.",

        Notes: "Notes",
        statementCheck:
            "I have read, understood and agreed to the above terms and conditions",
        projectCoordinationCostTitle:
            "Administration cost / project coordination cost to be deducted ($)",
        projectCoordinationCostTitleExplanation:
            "(for cancelled activities only)",
        administrationCost: "Administration cost",
        projectCoordinationCost: "Project coordination cost",
        administrationCostTotal: "Total Administration cost",
        projectCoordinationCostTotal: "Total Project coordination cost",
        projectRefNo: "Project ref no.",
        venue: "Venue",
        nonEligibleStudents: "No. of non-eligible students participated",
        teachingAssistant: "Teaching assistant (if any)",
        cancellationActivityReason:
            "Please state the reason(s) for cancellation of the activity (if applicable)",
        completedByCollaboratingSchool:
            "To be completed by collaborating school",
        confirmDataAccurate:
            "I confirm that the data in the box above are accurate.",
        collaboratingSchoolName: "Name",
        collaboratingSchoolPost: "Post",
        collaboratingSchoolDate: "Date",
        collaboratingSchoolSign: "Sign",
        completedActivityDetails: "Details of completed activity",
        schoolPostOption: {
            principal: "Principal",
            supervisor: "Teacher in charge",
        },
        activeTableCheckMsg:
            "I have already checked all the information provided above to confirm the status of the above approved activity and to verify that all expenditure receipts are true and correct .",
        nGOHeadOption: {
            nGOHead: "Head of NGO",
            department: "Department",
            subsidiaryOrganisation: "Subsidiary Organisation",
            projectCoordinator: "Project Coordinator",
        },
        deductedGrantCancellationActivities:
            "Deducted Grant for Administration Cost due to cancellation of activities (E1 + E2)",
        deductedGrantAfterDeduction:
            "Approved Grant for Administration Cost after deduction (B) (B = A – E1 - E2)",
        deductedPercentage: "percentage to be deducted",
        costTableTitle:
            "School-based After-school Learning and Support Programmes {{schoolYear}} School Year ",
        projectEvaluationAttachment:
            "Have you conducted any survey to collect feedback on the activities under CBPs from the collaborating schools, participating students, parents, teachers and staff involved? If yes, please attach the survey results.",
        otherEvaluation:
            "If any other evaluation on the effectiveness on CBPs was also conducted, such as whether the aims of the project can be achieved and the response of schools and parents to the project, please state below.",
        headName:
            "Name and Post of Head of NGO / Department / Subsidiary Organisation / Project Coordinator",
        applicantInformation: "Applicant Information",
        ngoTypeLabel: "NGO/Department/Subsidiary Organisation",
        ngoType:
            "Name of NGO/Name of Department/Name of Subsidiary Organisation",
        ngoName: "Name of {{ngoType}}",
        ngoHeadType:
            "Head of NGO/Department/Subsidiary Organisation/Project Coordinator",
        ngoHeadTypeName: "Head of {{ngoType}}/Project Coordinator",
        ngoHeadName: "Name of NGO Project Coordinator",
        ngoHeadPost: "Post of NGO Project Coordinator",
        ngoChargeName: "Name of NGO Head",
        ngoChargePost: "Post of NGO Head",
        ngoHead: "Head of {{ngoType}}",
        incomeExpenditureToBeCompleted:
            "Statement of Activity Income & Expenditure(To be review and completed by school teacher/head)",
        uploadFile: "Uploaded File",
        formATitle:
            "attachment upload section(NGOs upload the completed form with signature and other supplementary documents)",
        formBTitle:
            "attachment upload section(NGOs upload the completed form with signature and other supplementary documents)",
        cancelledActivityTitle: "(cancelled)",
    },
    comma: ", ",
    semicolon: ";",
    select: {
        ngoOption: {
            ngo: "NGO",
            department: "Department",
            subsidiaryOrganisation: "Subsidiary Organisation",
        },
        ngoHeadOption: {
            ngoHead: "Head",
            projectCoordinator: "Project Coordinator",
        },
    },
    errorMsg: {
        "E-0000": "Nominee Title is required [E-0000]",
        "E-0001": "Nominee Name is required [E-0001]",
        "E-0100": "Reward Nomination is required [E-0100]",
        "E-0101":
            "Contains English characters, spaces, dot, comma, hyphen and single quote. Numbers are not allowed.",
        "E-0102": "Chinese-only",
        "E-0103":
            "Must not be blank if Chinese Name in Chinese Commercial Code is not blank.",
        "E-0104": "alphabets only",
        "E-0105": "alpha-numeric only",
        "E-0106":
            "Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()) and hyphen (-).",
        "E-0107": "Numeric only",
        "E-0108":
            "Allow one decimal place. Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()), hyphen (-) and slash (/).",
        "E-0109": "Not match 20XX\\XX format",
        "E-0110": "The value is after the date of birth.",
        "E-0111": "Must have at least 1 file",
        "E-0112": "Must be no more than 2 files",
        "E-0113": "Not match HKID rules",
        "E-0114": "Min 8 length",
        "E-0115": "Max 20 length",
        "E-0116":
            "Minimum length, Maximum length (default 100), Character type (alphabets only/alpha-numeric/Chinese-only), Pattern Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()) and hyphen (-)",
        "E-0117":
            "Minimum length, Maximum length (default 100), Character type (alphabets only/alpha-numeric/Chinese-only), Pattern",
        "E-0118": "Must be a positive integer",
        "E-0119": "Must be a floating point number. Maximum: 100,",
        "E-0120": "One of the first 2 items is required",
        "E-0121":
            "The integer part has 6 digits at most and 2 decimals at most.",
        "E-0122": "One of the two parts is required",
        "E-0123": "{{fildName}} not repeatable",
        "E-0124": "This field must be at least {{number}} characters",
        "E-0125": "this field must have at least 1 items",
        "E-0126": "One of the first three fields must be filled in",
        "E-0127": "This field must be less than or equal to the {{fildName}}",
        "E-0128": "Please do not select duplicate school type",
    },
    statement: {
        tips1: "1. All information of the e-Form contained herein shall be subject to the application form on the EDB website",
        tipsUrl:
            "https://www.edb.gov.hk/en/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. School-based After-school Learning and Support Programmes  Community-based Project – Final Report (up to 31 July of the school year) (This form, duly completed and signed, should be returned to the Student Special Support Section of EDB on or before 30 September of the year)",
    },
};
export default Form012EN;
